export enum TYPES_MEMBERSHIPS {
    GOLD = 'GOLD',
    PLATINUM = 'PLATINUM',
    DIAMOND = 'DIAMOND',
}
